import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { IntegrationCall, IntegrationCallService } from 'src/app/core/integration-call.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-buyers-requests-dialog',
  templateUrl: './buyers-requests-dialog.component.html',
  styleUrls: ['./buyers-requests-dialog.component.scss'],
})
export class BuyersRequestsDialogComponent {
  is_list_requests_running: boolean = false;
  buyer_id?: string;
  integration_calls?: IntegrationCall[];

  constructor(
    private dialog_ref: MatDialogRef<BuyersRequestsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private integration_call_service: IntegrationCallService,
    private error_service: ErrorService,
  ) {
    this.buyer_id = data.buyer_id;
  }

  ngOnInit(): void {
    if (this.buyer_id) {
      this.listIntegrationCall(this.buyer_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  listIntegrationCall(buyer_id: string): void {
    this.is_list_requests_running = true;
    this.integration_call_service.list(buyer_id).subscribe({
      next: response => {
        this.integration_calls = response.data;
        this.is_list_requests_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_list_requests_running = false;
      },
    });
  }

  getParsedJSON(raw?: string): any {
    if (!raw) return '';
    return JSON.parse(raw);
  }
}
